/**
 * HubBootLoader — dedicated Prophets loading screen.
 *
 * Shown while the Hub is resolving the minimum bootstrap state
 * (session + /hub/me) so users never see a partially-hydrated shell
 * during initial refresh / login. Also used as the App-level
 * `Suspense fallback` for lazy Hub route chunks, so navigating
 * between modules on a cold chunk shows an intentional loader
 * instead of a frozen previous page or a blank div.
 *
 * Kept intentionally light: pure CSS animations, no images or
 * animation libraries, single stylesheet, no network fetch of its
 * own. The bundle cost is a few kilobytes and it always renders in
 * the same paint cycle it is mounted in.
 */
import "./HubBootLoader.css";

export default function HubBootLoader({ label }) {
  return (
    <div className="hub-boot" role="status" aria-live="polite"
         data-testid="hub-boot-loader">
      <div className="hub-boot__orb">
        <div className="hub-boot__ring hub-boot__ring--a" />
        <div className="hub-boot__ring hub-boot__ring--b" />
        <div className="hub-boot__core" />
      </div>
      <div className="hub-boot__title">PROPHECY IS LOADING</div>
      <div className="hub-boot__sub">{label || "The future is forming."}</div>
    </div>
  );
}
